import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import WhatsResourcesData from './Data';
import WhatsResourcesView from './View';

const WhatsResourcesEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <WhatsResourcesView {...props} />
      <SidebarPortal selected={selected}>
        <WhatsResourcesData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(WhatsResourcesEdit);
